import Action from 'redux/Action';
import React, {createContext, ReactNode, useContext, useReducer} from 'react';

type SwitchStacksAccordionState = Map<string, Record<string, boolean>>;
type SwitchStacksAccordionStateContext = {
  state: SwitchStacksAccordionState;
  dispatch: React.Dispatch<any>;
};

const SwitchStacksAccordionStateContext = createContext<SwitchStacksAccordionStateContext>(
  {} as SwitchStacksAccordionStateContext
);

const reducer = (state: SwitchStacksAccordionState, action: Action): SwitchStacksAccordionState => {
  switch (action.type) {
    case 'TOGGLE_SWITCH_STACK_ACCORDION':
      const switchStack = state.get(action.payload.switchStack)!;
      switchStack[action.payload.view] = !switchStack[action.payload.view];
      state.set(action.payload.switchStack, switchStack);
      return new Map(state);
    case 'EXPAND_ALL_SWITCH_STACKS_ACCORDION':
      return new Map(
        Array.from(state).map(([switchStack]) => [
          switchStack,
          {
            diagram: true,
            table: true,
          },
        ])
      );
    case 'COLLAPSE_ALL_SWITCH_STACKS_ACCORDION':
      return new Map(
        Array.from(state).map(([switchStack]) => [
          switchStack,
          {
            diagram: false,
            table: false,
          },
        ])
      );
    default:
      return state;
  }
};

export default function SwitchStacksAccordionStateProvider({
  children,
  stackNames,
}: {
  children: ReactNode;
  stackNames: string[];
}) {
  const [state, dispatch] = useReducer(
    reducer,
    new Map(
      stackNames.map(stack => [
        stack,
        {
          diagram: true,
          table: true,
        },
      ])
    )
  );

  return (
    <SwitchStacksAccordionStateContext.Provider value={{state, dispatch}}>
      {children}
    </SwitchStacksAccordionStateContext.Provider>
  );
}

export const useSwitchStacksAccordionState = () => {
  const context = useContext(SwitchStacksAccordionStateContext);

  if (context === undefined) {
    throw new Error(
      'useSwitchStacksAccordionState must be within SwitchStacksAccordionStateProvider'
    );
  }

  return context;
};
